import MenuItem from "./MenuItem";
import useMenuItems from "./useMenuItems";
import { Dispatch, SetStateAction } from "react";
interface MenuItemsProps {
  sidebarOpen: boolean;
  setSidebarOpen: Dispatch<SetStateAction<boolean>>; // Type for the setState function
}

function MenuItems({ sidebarOpen, setSidebarOpen }: MenuItemsProps) {
  const menuItems = useMenuItems();

  return (
    <div className="border-t border-[#EEEFF2] h-[63%]">
      {menuItems.map((item) => (
        <MenuItem
          menuItem={item}
          key={item.name}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen} // Pass setSidebarOpen down
        />
      ))}
    </div>
  );
}

export default MenuItems;
